'use client';

import { useSessionStore } from '@/store/session';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from '../ErrorPage';

export const GenericError = () => {
  const { t } = useTranslation();

  const originalRequestUrl = useSessionStore((s) => s.originalRequestUrl);
  const originalSessionId = useSessionStore((s) => s.originalSessionId || '');

  return (
    <ErrorPage
      pageName={
        originalRequestUrl ? 'GenericErrorWithContinue' : 'GenericError'
      }
      title={t('It looks like something unexpected happened')}
      subtitle={originalRequestUrl ? t('try again') : t('dont worry')}
      data-testid="GenericError"
      actionLabel={t(originalRequestUrl ? 'lets try again' : 'Go to homepage')}
      action={
        originalRequestUrl
          ? {
              id: 'error-continue-button',
              // @ts-expect-error missing types
              'data-testid': 'error-continue-button',
              href: `${originalRequestUrl}&original_session_id=${originalSessionId}`,
            }
          : {
              id: 'error-homepage-button',
              'data-testid': 'error-homepage-button',
              href: 'https://www.asurion.com/',
              target: '_blank',
            }
      }
    />
  );
};
